<template>
  <div id=''  class='' >

    <tyc :tqobj='tqobj'></tyc>

    <el-dialog  class='gDia' :title="config.callback? $t('app_eqcapture'):$t('app_catchlog')" v-model="pushdev" @close='handleClose'  size=''>
      <div v-loading='loading' id='' class='gBorder'>

        <el-row style=''>
          <!-- <el-col :span="12">
            <el-button type='primary' :disabled="multipleTable.length == 0" @click='bcPush' class='gSgLeftBtn' style=''>{{$t('app_pushsldev')}}</el-button>
            <el-button type='primary' class='' @click='pushAll()' style=''>{{$t('app_pushAll')}}</el-button>
            <el-button type='primary' class='' @click='fileImport()' style=''>{{$t('app_fileImport')}}</el-button>
          </el-col> -->

          <el-col v-show='true' :offset="0" :span="4">
            <div class='gSgLeftBtn'>
              <el-select @change='getCmDv' style='' v-model="cmtStatus" :placeholder="$t('app_status')">
                <el-option
                  v-for="item in cmtStatusArr"
                  :key="item.vl"
                  :label="item.lb"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col>


          <el-col v-show='true' :offset="0" :span="4">
            <!-- <div class='gCtrl'><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div> -->
            <div class='gCtrl' style="padding-left: 8px;">
              <MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector>
            </div>
          </el-col>
          <el-col v-show='true'  :span="4">
            <div class='gSideCtrl'><el-input  :placeholder="$t('app_terNo')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
          </el-col>
        </el-row>

        <el-table
        class='gTopMg'
        ref="multipleTable"
        id='dpTable'
        :data="tableData"
        border

        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
          <!-- <el-table-column
            type="selection"
            align='center'
            width="55">
          </el-table-column> -->
          <el-table-column
            prop="terminalNo"
            align='center'
            :label="$t('app_terNo')"
            width="210">
          </el-table-column>
          <el-table-column
            align='center'
            prop="terminalName"
            :label="$t('app_terName')"
            width="210">
          </el-table-column>
          <el-table-column
            prop="terminalStatus"
            align='center'
            :label="$t('app_status')"
            width="210">
            <template slot-scope="scope">

            <span v-if='isNon'>
                <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_enable')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
              </span>
              <span v-else>
                <tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
              </span>
          </template>
          </el-table-column>
          <el-table-column
            align='center'
            prop="mechName"
            :label="$t('app_distributor')"
            width="210">
          </el-table-column>

          <el-table-column
            prop="operate"
            :label="$t('app_operate')"
            align='center'

            width='106'>
            <template slot-scope='scope'>


              <el-tooltip class="item" effect="dark" :content="config.callback?$t('app_scapture'):$t('app_catch')" placement="top">
                <el-button   @click='catched(scope.row)' type=text><i class="fa fa-hand-paper-o" style=""></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>

        <div class="gPgDiv">

          <el-pagination
          class='gPg'
          @current-change="pageSelect"
          @size-change="pageSized"
          :current-page="page"
          :page-sizes='$gRows'
          :page-size="$gRow"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <el-dialog class='gDia' :title="$t('app_fipush') " v-model="pushImport" @close='closeImport'>
        <el-form model="" rules="" ref="">
          <el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

            <el-upload
              class="upload-demo"
              ref="upload"
              name="fileUpload"
              :action="importTemplate"
              :on-remove="handleRemove"
              :before-upload="srcBefore"
              :on-success="srcSuccess"
              :on-error='ulError'
              :file-list="fileList"
              :auto-upload="true">
              <el-button slot="trigger" size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
              <a :href="downTpl" style="margin-left:8px;margin-right:10px;"><el-button type="success" size='small'>{{$t('terminal.list.import_muban')}}</el-button></a>
            </el-upload>

          </el-form-item>
          <el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
            {{uldata?uldata.terNums : 0 + $t('app_amechine')}}
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!-- <span style="margin-right:10px;" v-show="info.type === '1'">
            <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
          </span>
          <span style="margin-right:10px;" v-show="info.type === '2'">
            <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
          </span> -->
          <el-button @click="pushImport = false">{{$t('app_cancel')}}</el-button>
          <el-button :disabled="!uldata" style="margin-left: 10px;"  type="primary" @click="submitUpload">{{$t('app_srpush')}}</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<style>

</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  // import mm from 'moment'
  import { url,urlAssets } from '@/api/url'
  import tyc from '@/components/global/tyc'
  import tagc from '@/components/global/tagc'
  export default{

    data () {
      var that = this
      return {
        tqobj: '',
        cmtStatus: '',
        cmtStatusArr: [],
        isNon: false,
        downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
        formLabelWidth: '28.5%',
        fileList: [],
        uldata: '',
        snum: 0,
        check1: false,
        check2: false,
        pushImport:false,
        tableData: [],
        total: 0,
        page: 1,
        multipleTable: [],
        loading: false,
        pushdev: false,
        mech: '',
        queryKey: '',
        importTemplate: `${urlAssets.prefix}tms-server-web/import/terminalList.do`,
        mechanismData: {
          value: null,
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.mech = value
            that.getCmDv()
          }
        }
      }
    },
    props: [
      // "taskId",
      // "close",
      /** 模块化 */
      "config"
    ],
    watch: {
      // taskId: function (newVl, oldVl) {
      //    if (!this.pushdev && newVl) {
      //      this.pushdev = true
      //    }
      // },
      config: function(newVl, oldVl) {
        if (!this.pushdev && newVl) {

          // this.queryKey = ''
          this.getCmDv()
           this.pushdev = true
         }
      }
    },
    components: {
      MechanismSelector,tyc,tagc
    },
    computed: {

    },
    methods: {
      submitUpload () {
        //console.log(this.uldata)
        // this.bindRqs('2')

        if (this.config.type == 1) {
          this.loading = true
          this.$sysconfigPush(this.config.configId, '', '2', '', '', this.uldata.fileNo,'','', (res) => {
            this.loading = false
            if (res.status === 200) {
              //console.log(res.data)
              this.$message.success(res.message)
              this.pushdev = false
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = false
          })
          this.pushImport = false
          return
        }

        this.loading = true
        this.$appendPush(this.config.taskId, '', '2', '', '', this.uldata.fileNo, '','','', (res) => {
          this.loading = false
          if (res.status === 200) {
            //console.log(res.data)
            this.$message.success(res.message)
            this.pushdev = false
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = false
        })

        this.pushImport = false
      },
      ulError () {
        window[this.$route.path] = ''
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        //console.log(res, this.fileList)

        if (res.status === 200) {
          this.fileList = [{name: file.name}]
          this.uldata = res.data
        } else {

          this.srcList = []

          this.$message.error(res.message)
        }
      },
      srcBefore (file) {
        window[this.$route.path] = 1
      },
      closeImport () {
        this.fileList = []
        this.uldata = ''
      },
      handleClose (row) {
        // this.pushdev = false
        if (this.config.close) {
          this.config.close(row)
        }
        this.cmtStatus = ''
        this.mech = ''
        this.queryKey = ''
        this.pushdev = false

      },
      handleSelectionChange (vl) {
        this.snum = vl.length
        this.multipleTable = vl
      },
      query () {
        this.getCmDv()
      },
      fileImport () {
        this.pushImport = true
      },
      pushAll () { 
        this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {

          if (this.config.type == 1) {
            this.loading = true
            this.$sysconfigPush(this.config.configId, '', '1', this.mech, this.queryKey, '','','', (res) => {
              this.loading = false
              if (res.status === 200) {
                //console.log(res.data)
                this.$message.success(res.message)
                this.pushdev = false
              } else {
                this.$message.error(res.message)
              }
            }, () => {
              // error
              this.loading = false
            })
            return
          }

					var terminalstats = this.cmtStatus

          this.loading = true
          this.$appendPush(this.config.taskId, '', '1', this.mech, this.queryKey, '', terminalstats,'','', (res) => {
            this.loading = false
            if (res.status === 200) {
              //console.log(res.data)
              this.$message.success(res.message)
              this.pushdev = false
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = false
          })
        }, '')
      },
      bcPush () {
        var nos = []
        this.multipleTable.forEach(obj => {
          nos.push(obj.terminalNo)
        })

        var tip = this.$t('app_surepsxdv').replace('{num}', this.multipleTable.length)

        this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.pushRqs(nos.toString())
        }, '')
      },
      catched (row) {
        var msg = this.config.callback? this.$t('app_surestcap'):this.$t('app_iscatch')
        this.$showConfirm(this.$t('app_tip'), msg, this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          if (this.config.callback) {
            this.handleClose(row)
          } else
          this.pushRqs(row.terminalNo)
        }, '')
      },
      pushRqs (nos) {
        this.loading = true
        var logId = ''
        this.$operateTerLog('1', logId, nos, (res) => {
          this.loading = false
          if (res.status === 200) {
            //console.log(res.data)
            this.$message.success(res.message)
            // this.pushdev = false
            this.handleClose()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = false
        })
        // if (this.config.type == 1) {
        //   this.$sysconfigPush(this.config.configId, nos, '0', '', '', '', (res) => {
        //     this.loading = false
        //     if (res.status === 200) {
        //       //console.log(res.data)
        //       this.$message.success(res.message)
        //       this.pushdev = false
        //     } else {
        //       this.$message.error(res.message)
        //     }
        //   }, () => {
        //     // error
        //     this.loading = false
        //   })
        //   return
        // }

        // this.$appendPush(this.config.taskId, nos, '0', '', '', '','', (res) => {
        //   this.loading = false
        //   if (res.status === 200) {
        //     //console.log(res.data)
        //     this.$message.success(res.message)
        //     this.pushdev = false
        //   } else {
        //     this.$message.error(res.message)
        //   }
        // }, () => {
        //   // error
        //   this.loading = false
        // })
      },
      pageSized (vl) {
        this.$gRow = vl
        this.getCmDv()
      },
      pageSelect (vl) {
        this.page = vl
        this.getCmDv()
      },
      getCmDv () {

        // if (this.config.type == 1) {
        //   this.getDv()
        //   return
        // }

        if (this.config.type != 1 && (this.config.taskType == 6 || this.config.taskType == 14 || this.config.taskType == 15)) {
          this.isNon = true
          this.getNonDevices()
        } else {
          this.isNon = false
          this.getDv()
        }

				var _this = this
				var typeKey = this.isNon?'nonTerTypes':'terminalTypes'
				this.tqobj = {
					keys: [typeKey],
					callback: (data) => {
						_this.cmtStatusArr=data[0]
					}
				}
      },
      getNonDevices () {
        var channel = this.mech
        var terminalNo = this.queryKey
        var status =  this.cmtStatus
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
        this.loading = 1
        this.$getNonItDv(this.page, this.$gRow, channel, terminalNo, status,'', '', '','','', (res) => {
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })

      },
      getDv () {

        this.loading = true
        var mc = this.mech
        var tno = this.queryKey
        var tstatus = this.cmtStatus
        var trstatus = ''


        this.$getDvDevices(this.page, this.$gRow, mc, tno, tstatus, trstatus, '', '','','', (res) => {
          this.loading = 0
          if (res.status === 200) {
            //console.log(res.data)
            this.tableData = res.data
            this.total = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      test () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          // this.loading = 1
          // this.$submitVideo(row.videoid, (res) => {
          //   this.loading = 0
          //   if (res.status === 200) {
          //     this.$message.success(res.message)
          //     this.getList()
          //   } else {
          //     this.$message.error(res.message)
          //   }
          // }, (error) => {
          //   this.loading = 0
          // })

        }, '')
      }
    },
    mounted () {

    },
    destroyed () {

    }
  }
</script>



// WEBPACK FOOTER //
// eqdia.vue?5570c73c